import React from "react";
import defaultIconSettings from "./defaultIconSettings";

const CheckIcon = ({
    color = defaultIconSettings.color,
    size = defaultIconSettings.size,
    className = defaultIconSettings.className,
}) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 18 14"
            style={{ height: size, width: size }}
            className={className}
        >
            <path
                fill={color}
                d="M6.32724 12.9701L0.910572 7.55342C0.585148 7.22799 0.585148 6.70036 0.910572 6.3749L2.08906 5.19638C2.41448 4.87093 2.94215 4.87093 3.26757 5.19638L6.9165 8.84528L14.7321 1.02971C15.0575 0.704289 15.5852 0.704289 15.9106 1.02971L17.0891 2.20823C17.4145 2.53365 17.4145 3.06129 17.0891 3.38675L7.50576 12.9701C7.1803 13.2955 6.65267 13.2955 6.32724 12.9701Z"
            />
        </svg>
    );
};

export default CheckIcon;
